import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as EmptyContactsIcon } from '../../../../assets/images/EmptyContactsTable.svg';
import { ReactComponent as ImportIcon } from '../../../../assets/images/import.svg';
import ReactTable from '../../../../components/ReactTable/ReactTable';

import ContactsColumnHeaders from './ContactsColumns';

const ContactsTable = ({
  contacts,
  perPage,
  setPage,
  setPerPage,
  pageInfo,
  handleOnToggleContact,
  selectedContacts,
  handleOpenModal,
  loading,
  navigateToSyncSources,
  toggleDeleteOption,
  searchTerm,
  appliedFiltersCount,
}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleViewRecommendations = (contactId) => {
    navigate(`/account/network/contact/${contactId}/recommendations`);
  };

  const EMPTY_TITLE = useMemo(() => {
    if (searchTerm || appliedFiltersCount) {
      return t('contacts.noContactsFound');
    }
    return t('contacts.noContactsYet');
  }, [searchTerm, appliedFiltersCount, t]);

  return (
    <div>
      <ReactTable
        data={contacts}
        columns={ContactsColumnHeaders(handleOpenModal, pageInfo?.count, toggleDeleteOption, t, handleViewRecommendations)}
        onSelectRow={handleOnToggleContact}
        selectedItems={selectedContacts}
        defaultSortingState={[]}
        setSortingState={() => {}}
        defaultStyling={{ header_height: 'header-height' }}
        defaultFeildSize={1.35}
        emptyTitle={EMPTY_TITLE}
        emptyIcon={EmptyContactsIcon}
        loading={loading}
        perPage={perPage}
        setPage={setPage}
        setPerPage={setPerPage}
        pageInfo={pageInfo}
        showCheckBox
        emptyCTATitle={t('contacts.importContacts')}
        emptyCTAIcon={ImportIcon}
        emptyCTA={navigateToSyncSources}
      />
    </div>
  );
};

export default ContactsTable;
